import { Button } from "app/components/button";
import { ConditionalButton } from "app/components/buttons";
import { CardBody } from "app/components/card-body";
import { CardFooter } from "app/components/card-footer";
import { CardHeader } from "app/components/card-header";
import { Checkbox } from "app/components/checkbox";
import { Column } from "app/components/column";
import { Container } from "app/components/container";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Input } from "app/components/input";
import { RouteError } from "app/components/route-error";
import { Row } from "app/components/row";
import { useEmpresa } from "app/contexts";
import { urlRegex } from "app/utils";
import { useEffect } from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";

const initialState = {
  pagina: {
    pagina_web_url: "",
    pagina_web_principal: false,
  },
  error: null,
};

export function PaginaWebForm() {
  const params = useParams();
  const navigate = useNavigate();

  const { addPaginaWeb, getPaginaWeb, updatePaginaWeb } = useEmpresa();

  const [state, setState] = useState(initialState);

  useEffect(() => {
    try {
      if (!!params.index) {
        const pagina = getPaginaWeb(parseInt(params.index));

        setState((state) => ({ ...state, pagina }));
      }
    } catch (error) {
      setState((state) => ({ ...state, error }));
    }
  }, [params.index, getPaginaWeb]);

  function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!params.index) {
        const updated = updatePaginaWeb(parseInt(params.index), state.pagina);

        if (!!updated) {
          toast.success("¡Dirección de página web actualizada!");

          return navigate("../../");
        }
      } else {
        const added = addPaginaWeb(state.pagina);

        if (!!added) {
          toast.success("¡Dirección de página web agregada!");

          return navigate("../../");
        }
      }
    } catch (error) {
      return toast.error(error.message);
    }
  }

  if (!!state.error) {
    return <RouteError message={state.error.message} navigateTo="../../" />;
  }

  return (
    <div className="col-sm-12 col-xl-6 offset-xl-3">
      <form className="card" onSubmit={handleSubmit}>
        <CardHeader
          header={`${
            !!params.index ? "Editar" : "Agregar"
          } dirección de página web`}
        />

        <CardBody>
          <Container>
            <Row>
              <Column>
                <Input
                  placeholder="Dirección de página web o red social"
                  value={state.pagina.pagina_web_url}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      pagina: {
                        ...state.pagina,
                        pagina_web_url: e.target.value,
                      },
                    }))
                  }
                  title="p. ej. www.miempresa.com, www.facebook.com/nombre-de-usuario o www.instagram.com/nombre-de-usuario"
                  pattern={urlRegex.source}
                  autoFocus
                />
              </Column>

              <Column>
                <Checkbox
                  label="¿Es una direccón de página web principal?"
                  checked={state.pagina.pagina_web_principal}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      pagina: {
                        ...state.pagina,
                        pagina_web_principal: e.target.checked,
                      },
                    }))
                  }
                />
              </Column>
            </Row>
          </Container>
        </CardBody>

        <CardFooter>
          <DFlexResponsive justifyContent="end">
            <ConditionalButton
              type="submit"
              condition={!params.index}
              titleWhenTrue="Agregar"
              titleWhenFalse="Actualizar"
            />

            <Button
              color="secondary"
              title="Cancelar"
              outline
              onClick={() => navigate("../../")}
            />
          </DFlexResponsive>
        </CardFooter>
      </form>
    </div>
  );
}
